import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src", "alt", "width", "height"]
const _hoisted_3 = ["src", "alt", "width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.image)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.url)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.url
            }, [
              _createElementVNode("img", {
                src: _ctx.image,
                alt: _ctx.title,
                width: _ctx.width,
                height: _ctx.height
              }, null, 8, _hoisted_2)
            ], 8, _hoisted_1))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.image,
              alt: _ctx.title,
              width: _ctx.width,
              height: _ctx.height
            }, null, 8, _hoisted_3))
      ], 64))
    : _createCommentVNode("", true)
}